// extracted by mini-css-extract-plugin
export default {"classOfTradePopover":"sandozStyles_classOfTradePopover__6vT5C"};